import React, {Component} from 'react';
import {API_URL} from "../../settings/local_settings";
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import {Switch} from "../buttons/Swtich";


export class UserModuleManageAccountsInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            userModuleManageAccountsInfo: null,
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    userModuleManageAccountsDataURL() {
        return API_URL + 'user/' + this.props.userId + '/module/manage-accounts';
    }

    setIsSaving(new_value) {
        this.setState({
            ...this.state,
            'isSaving': new_value
        });
    }

    getUserModuleManageAccountsData() {
        this.setIsSaving(true);
        new APIClient(this.userModuleManageAccountsDataURL()).call('GET').then((data) => {
            this.setIsSaving(false);
            if (data.status === 'NO_MODULE_ACCESS') {
                alert("El usuario no tiene acceso a éste módulo. En la solapa SEGURIDAD podrás hacerlo 🙂");
            }
            else if (data.status === 'ERROR') {
                alert(data['error_message']);
            } else if (data.status === 'OK') {

                this.setState({
                    userModuleManageAccountsInfo: {
                        'googleManagerId': data.data['google_manager_id'],
                        'canEditManagerAdspentLimit': data.data['can_edit_manager_adspent_limit'],
                        'canCreateAdAccounts': data.data['can_create_ad_accounts'],
                        'canGiveAccessToAdAccounts': data.data['can_give_access_to_ad_accounts']
                    }
                });
            }
        })
    }


    componentDidMount() {
        this.getUserModuleManageAccountsData();
    }

    handleSubmit() {
        this.setState({savingChanges: true});
        new APIClient(this.userModuleManageAccountsDataURL()).call('POST', {
            'google_manager_id': this.state.userModuleManageAccountsInfo.googleManagerId,
            'can_edit_manager_adspent_limit': this.state.userModuleManageAccountsInfo.canEditManagerAdspentLimit,
            'can_create_ad_accounts': this.state.userModuleManageAccountsInfo.canCreateAdAccounts,
            'can_give_access_to_ad_accounts': this.state.userModuleManageAccountsInfo.canGiveAccessToAdAccounts

        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit();
            }
            this.setState({
                userModuleManageAccountsInfo: {
                    ...this.state.userModuleManageAccountsInfo,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;
        const switchesNames = ["canEditManagerAdspentLimit", "canCreateAdAccounts", "canGiveAccessToAdAccounts"]
        const value = switchesNames.includes(name) ? target.checked : target.value;

        this.setState({
            userModuleManageAccountsInfo: {
                ...this.state.userModuleManageAccountsInfo,
                [name]: value
            }
        });
    }

    renderSaveButton() {
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value="Guardar"/>;
        }
    }

    renderUserModuleManageAccountsInfo() {
        if (this.state.userModuleManageAccountsInfo !== null) {
            const result = [
                <div key={"1"} className="box">
                    <div className="form-row">
                        <label>Id del MCC al que accede:</label>
                        <input onChange={this.handleChange} name="googleManagerId" type="text"
                               value={this.state.userModuleManageAccountsInfo.googleManagerId}/>
                    </div>
                    <div className="form-row">
                        <label>Puede editar el tope del MCC</label>
                        <Switch onChange={this.handleChange}
                                checked={this.state.userModuleManageAccountsInfo.canEditManagerAdspentLimit}
                                name="canEditManagerAdspentLimit"
                                messageToAlertUserIfChecked={null}
                        />
                    </div>
                    <div className="form-row">
                        <label>Puede crear cuentas</label>
                        <Switch onChange={this.handleChange}
                                checked={this.state.userModuleManageAccountsInfo.canCreateAdAccounts}
                                name="canCreateAdAccounts"
                                messageToAlertUserIfChecked={null}
                        />
                    </div>
                    <div className="form-row">
                        <label>Puede dar accesos</label>
                        <Switch onChange={this.handleChange}
                                checked={this.state.userModuleManageAccountsInfo.canGiveAccessToAdAccounts}
                                name="canGiveAccessToAdAccounts"
                                messageToAlertUserIfChecked={null}
                        />
                    </div>
                </div>
            ]

            return result
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        return (
            <form className="section-body-item -wide">
                {this.renderUserModuleManageAccountsInfo()}
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

